var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Dropdown, DropdownClose, DropdownDownArrow, TextInput, } from '@leapfinance/geebee-component-library';
import { Divider, IconButton, Popover } from '@mui/material';
import classNames from 'classnames';
import { CFFilterContext } from './CFFilterProvider';
import { isFalsy } from '../../../../utils/common';
var StudentRegionFilter = function (props) {
    var _a, _b, _c;
    var initialEligiblityValues = useContext(CFFilterContext).initialEligiblityValues;
    var countries = props.countries;
    var _d = __read(useState([]), 2), selectedStateOptions = _d[0], setSelectedStateOptions = _d[1];
    var countryOptions = ((_b = (_a = countries === null || countries === void 0 ? void 0 : countries.data) === null || _a === void 0 ? void 0 : _a.map(function (country) { return ({
        label: country === null || country === void 0 ? void 0 : country.labelValue,
        value: country === null || country === void 0 ? void 0 : country.labelKey,
    }); })) !== null && _b !== void 0 ? _b : []);
    var _e = __read(useState(), 2), selectedCountry = _e[0], setSelectedCountry = _e[1];
    var _f = __read(useState(), 2), selectedState = _f[0], setSelectedState = _f[1];
    var _g = __read(React.useState(null), 2), anchorEl = _g[0], setAnchorEl = _g[1];
    var open = Boolean(anchorEl);
    var id = open ? "region-filter-popover" : undefined;
    var inputRef = useRef(null);
    useEffect(function () {
        setSelectedCountry(initialEligiblityValues === null || initialEligiblityValues === void 0 ? void 0 : initialEligiblityValues.studentCountryId);
        if (initialEligiblityValues === null || initialEligiblityValues === void 0 ? void 0 : initialEligiblityValues.studentCountryId) {
            handleCountryChange(initialEligiblityValues === null || initialEligiblityValues === void 0 ? void 0 : initialEligiblityValues.studentCountryId);
        }
        setSelectedState(initialEligiblityValues === null || initialEligiblityValues === void 0 ? void 0 : initialEligiblityValues.studentStateId);
    }, [initialEligiblityValues]);
    var handleClose = function (isApplied) {
        setAnchorEl(null);
        setTimeout(function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }, 0);
        if (!isApplied) {
            setSelectedCountry(initialEligiblityValues === null || initialEligiblityValues === void 0 ? void 0 : initialEligiblityValues.studentCountryId);
            setSelectedState(initialEligiblityValues === null || initialEligiblityValues === void 0 ? void 0 : initialEligiblityValues.studentStateId);
        }
    };
    var handleStateChange = function (value) {
        if (isFalsy(value)) {
            setSelectedState(undefined);
            return;
        }
        setSelectedState(value);
    };
    var handleCountryChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var states, stateOptions;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (isFalsy(value)) {
                        setSelectedCountry(undefined);
                        setSelectedState(undefined);
                        return [2 /*return*/];
                    }
                    setSelectedState(undefined);
                    setSelectedCountry(value);
                    return [4 /*yield*/, props.onGetStateOptions({
                            country: (_a = value === null || value === void 0 ? void 0 : value.value) === null || _a === void 0 ? void 0 : _a.toString(),
                        })];
                case 1:
                    states = _c.sent();
                    stateOptions = ((_b = states === null || states === void 0 ? void 0 : states.map(function (state) { return ({
                        label: state === null || state === void 0 ? void 0 : state.labelValue,
                        value: state === null || state === void 0 ? void 0 : state.labelKey,
                    }); })) !== null && _b !== void 0 ? _b : []);
                    setSelectedStateOptions(stateOptions);
                    return [2 /*return*/];
            }
        });
    }); };
    var clearFilters = function () {
        var _a;
        setSelectedCountry(undefined);
        setSelectedState(undefined);
        setSelectedStateOptions([]);
        (_a = props === null || props === void 0 ? void 0 : props.onApply) === null || _a === void 0 ? void 0 : _a.call(props, {
            studentCountryId: undefined,
            studentStateId: undefined,
        });
    };
    var displayValue = selectedCountry || selectedState
        ? "".concat((_c = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.label) !== null && _c !== void 0 ? _c : "").concat((selectedState === null || selectedState === void 0 ? void 0 : selectedState.label) ? ", ".concat(selectedState === null || selectedState === void 0 ? void 0 : selectedState.label) : "")
        : "";
    return (React.createElement("div", { onClick: function (event) {
            if (!anchorEl) {
                setAnchorEl(event.currentTarget);
            }
        }, "data-hasValue": displayValue },
        React.createElement(TextInput, { label: "Student Region", keepDefaultLabelBehaviour: true, className: classNames("lfc-w-[190px]  lfc-transition-all "), InputLabelProps: { shrink: open || !!displayValue }, value: displayValue, size: "small", InputProps: {
                readOnly: true,
                endAdornment: (React.createElement(React.Fragment, null,
                    displayValue ? (React.createElement(IconButton, { onClick: function (event) {
                            event.stopPropagation();
                            clearFilters();
                        } },
                        React.createElement(DropdownClose, { size: "small" }))) : null,
                    React.createElement(DropdownDownArrow, { size: "small", classNames: classNames("", { 'lfc-rotate-180': open }) }))),
                sx: function (theme) {
                    var _a, _b, _c, _d, _e;
                    return displayValue && !open
                        ? {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a["200"],
                                fieldSet: {
                                    borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b["500"],
                                },
                                ':hover': {
                                    backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c["200"],
                                    // fieldSet: {
                                    //   borderColor: theme.palette.primary?.['500']
                                    // }
                                },
                                '.MuiInputAdornment-positionStart': {
                                    '.MuiTypography-root': {
                                        color: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d["500"],
                                    },
                                },
                                input: {
                                    textOverflow: "ellipsis",
                                    color: (_e = theme.palette.primary) === null || _e === void 0 ? void 0 : _e["500"],
                                },
                            },
                        }
                        : {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: "white",
                            },
                        };
                },
            }, type: "search", onClick: function (event) {
                if (!anchorEl) {
                    setAnchorEl(event.currentTarget);
                }
            }, inputRef: inputRef }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: function (_event) {
                handleClose();
            }, anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            }, transformOrigin: { vertical: 0, horizontal: 0 }, slotProps: {
            // paper: {
            //   sx: { overflow: 'visible' },
            //   elevation: 0,
            //   // onClick: (event) => {
            //   //   event.stopPropagation();
            //   // }
            // },
            // root: {
            //   onClick: () => {
            //     if (isCityOpen || isStateOpen) {
            //       setIsCityOpen(false);
            //       setIsStateOpen(false);
            //     } else {
            //       handleClose();
            //     }
            //   }
            // }
            }, className: "lfc-mt-1" },
            React.createElement("div", { className: "lfc-w-[380px] lfc-flex lfc-flex-col lfc-gap-3 lfc-pt-4   lfc-rounded-md lfc-border lfc-shadow-lg" },
                React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-3 lfc-px-4" },
                    React.createElement(Dropdown, { value: selectedCountry, options: countryOptions, textInputProps: {
                            label: "Country",
                            placeholder: "Select Country",
                        }, onChange: function (_event, values) {
                            handleCountryChange(values);
                        }, size: "small", enableVirtualization: true }),
                    React.createElement(Dropdown, { value: selectedState, options: selectedStateOptions, textInputProps: {
                            label: "State",
                            placeholder: "Select State",
                        }, onChange: function (_event, values) {
                            handleStateChange(values);
                        }, size: "small", noOptionsText: isFalsy(selectedCountry)
                            ? "Select a country first"
                            : "No states found for this country" })),
                React.createElement("div", { className: "lfc-flex lfc-flex-col" },
                    React.createElement(Divider, null),
                    React.createElement("div", { className: "lfc-self-end lfc-p-2 lfc-flex lfc-gap-2" },
                        React.createElement(Button, { variant: "tertiary", onClick: function () {
                                clearFilters();
                            } }, "Clear"),
                        React.createElement(Button, { onClick: function () {
                                var _a;
                                (_a = props === null || props === void 0 ? void 0 : props.onApply) === null || _a === void 0 ? void 0 : _a.call(props, {
                                    studentCountryId: selectedCountry,
                                    studentStateId: selectedState,
                                });
                                handleClose(true);
                            } }, "Apply")))))));
};
export default StudentRegionFilter;
//# sourceMappingURL=StudentRegionCFFilter.js.map